/**
 * PDFPreviewModal - Shows PDF preview with download option
 */
import React from 'react';
import { X, Download, Printer } from 'lucide-react';

const PDFPreviewModal = ({ isOpen, onClose, pdfUrl, filename, title = 'PDF Preview' }) => {
  if (!isOpen || !pdfUrl) return null;

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = filename || 'document.pdf';
    link.click();
  };

  const handlePrint = () => {
    const printWindow = window.open(pdfUrl, '_blank');
    printWindow?.print();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-5xl h-[90vh] flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gray-900 rounded-t-2xl">
            <h2 className="text-lg font-semibold text-white">{title}</h2>
            <div className="flex items-center gap-2">
              <button
                onClick={handlePrint}
                className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-slate-800 bg-white rounded-lg hover:bg-gray-100 transition-colors"
              >
                <Printer className="h-4 w-4" />
                Print
              </button>
              <button
                onClick={handleDownload}
                className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-white bg-cyan-600 rounded-lg hover:bg-cyan-700 transition-colors"
              >
                <Download className="h-4 w-4" />
                Download
              </button>
              <button
                onClick={onClose}
                className="p-2 text-gray-400 hover:text-white rounded-lg transition-colors"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>

          {/* PDF Viewer */}
          <div className="flex-1 p-4 bg-gray-100">
            <iframe
              src={pdfUrl}
              className="w-full h-full rounded-lg border border-gray-300"
              title="PDF Preview"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PDFPreviewModal;
